import { FastFilters } from '../fast_filters';
import { appendPreloader } from '../preloader';

export function init(fastFilters: FastFilters) {
  const container = document.querySelector('[data-mark=searchButton]');

  if (!container) {
    return () => [];
  }

  const button = container.querySelector('button');

  if (!button) {
    return () => [];
  }

  let removePreloader: (() => void) | undefined;

  const buttonClickListener = () => {
    fastFilters.scheduleClick('search', () => {
      if (removePreloader) {
        removePreloader();
        removePreloader = undefined;
      }
    });

    removePreloader = appendPreloader(button, {
      size: 13,
      color: '#fff',
      style: 'position:relative;top:2px;margin-left:8px;',
    });
  };

  button.addEventListener('click', buttonClickListener);

  return () => {
    button.removeEventListener('click', buttonClickListener);
  };
}
